import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicInverseLaplace = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="INVERSE LAPLACE TRANSFORM"
      videos={[
        "https://www.youtube.com/embed/cDbjDKpi0Wc?list=PLKS7ZMKnbPrQDOTrKMxawIXENqhLWWvgT",
        "https://www.youtube.com/embed/I1svK4H6vrk?list=PLU6SqdYcYsfIWugLkTq1nMoU3rDDx7xpG",
      ]}
      takeaways={[
        { text: "Partial Fractions:" },
        { text: "- First video" },
        { text: "Convolution Theorem:" },
        { text: "- Second video" },
        { text: "Focus more on convolution theorem" },
        { text: "Practice as many problems as you can" },
      ]}
      questions={[]} // Empty questions as there were none provided
      exampleVideos={[]} // Empty example videos
    />
);
}

export default ModuleSubtopicInverseLaplace;